import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import AccuracyTrends from './AccuracyTrends';
import ItemAccuracyTrends from './ItemAccuracyTrends';
import { useFolder } from '../contexts/FolderContext';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`all-tabpanel-${index}`}
      aria-labelledby={`all-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function AllAccuracyDashboard() {
  const [tabValue, setTabValue] = useState(0);
  const { selectedRunDate } = useFolder();

  const formatRunDateDisplay = (runDateStr) => {
    if (!runDateStr || runDateStr.length !== 8) return runDateStr || '';
    return `${runDateStr.substring(0, 4)}-${runDateStr.substring(4, 6)}-${runDateStr.substring(6, 8)}`;
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            color: 'primary.main',
            mb: 0.5
          }}
        >
          Summary - All Runs
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.primary' }}>
          <strong>Run Date:</strong> {formatRunDateDisplay(selectedRunDate)}
        </Typography>
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="all tabs">
          <Tab label="📈 Item Level Deep Dive" />
          <Tab label="📅 Weekly Summary" />
        </Tabs>
      </Box>
      <TabPanel value={tabValue} index={0}>
        <ItemAccuracyTrends />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <AccuracyTrends fileName="collated_comparison_aggregated" />
      </TabPanel>
    </Box>
  );
}

export default AllAccuracyDashboard;
